/**
 * The web app's tap-name list (core generated appcontrols-web-controls.ts, about 30 kB) is not in the main chunk: the production page
 * loads it right after start-up (controlsLoad.ts) and the tracker counts any tap in that gap once it arrives (core
 * EventTracker.setControls). The build swaps controlsEager.ts for controlsNone.ts (vite.config.ts lazyControls); tests have the list
 * from the start.
 */
import type { ControlList } from "@logwave/core";

let LIST: ControlList | null = null;
export const loadedControls = (): ControlList | null => LIST;
export const setControlList = (l: ControlList): void => { LIST = l; };
/** Fetches the list (once) and makes it the app's. */
export const loadControls = (): Promise<ControlList> =>
  LIST ? Promise.resolve(LIST) : import("./controlsLoad.ts").then(() => LIST!);
